<template>
  <div :class="$style.page">
    <BaseContainer :class="$style.container">
      <BaseLoader
        :class="$style.box"
        :is-active="isLoading"
      >
        <FormBox
          :heading="heading"
          :lead="lead"
        >
          <div :class="$style.section">
            <ul :class="$style.list">
              <li>
                <router-link
                  v-slot="{ navigate, href }"
                  :to="{ name: 'EditCompany/BillingDetails', params: { companyId: $route.params.companyId } }"
                  custom
                >
                  <a
                    :href="href"
                    :class="[$style.item, $style.isAction]"
                    @click="navigate"
                  >
                    <span :class="$style.icon" />
                    Change billing details
                  </a>
                </router-link>
              </li>
              <li>
                <router-link
                  v-slot="{ navigate, href }"
                  :to="{ name: 'EditCompany/IssueRenewal', params: { companyId: $route.params.companyId } }"
                  custom
                >
                  <a
                    :href="href"
                    :class="[$style.item, $style.isAction]"
                    @click="navigate"
                  >
                    <span :class="$style.icon" />
                    Issue a renewal
                  </a>
                </router-link>
              </li>
              <li>
                <router-link
                  v-slot="{ navigate, href }"
                  :to="{ name: 'EditCompany/EnabledFeatures', params: { companyId: $route.params.companyId } }"
                  custom
                >
                  <a
                    :href="href"
                    :class="[$style.item, $style.isAction]"
                    @click="navigate"
                  >
                    <span :class="$style.icon" />
                    Change enabled features
                  </a>
                </router-link>
              </li>
              <li>
                <router-link
                  v-slot="{ navigate, href }"
                  :to="{ name: 'EditCompany/UserLimit', params: { companyId: $route.params.companyId } }"
                  custom
                >
                  <a
                    :href="href"
                    :class="[$style.item, $style.isAction]"
                    @click="navigate"
                  >
                    <span :class="$style.icon" />
                    Change user limit
                  </a>
                </router-link>
              </li>
            </ul>
          </div>
          <div
            v-if="company?.invoices.length"
            :class="$style.section"
          >
            <h4 :class="$style.sectionHeading">
              Past invoices
            </h4>
            <ul :class="$style.list">
              <li
                v-for="invoice in company.invoices"
                :key="invoice.id"
              >
                <span :class="$style.item">
                  <span :class="$style.icon" />
                  {{ formatInvoiceDate(invoice.paid_until) }}
                </span>
              </li>
            </ul>
          </div>
        </FormBox>
      </BaseLoader>
    </BaseContainer>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import { format } from 'date-fns';
import BaseContainer from '@/components/base/Container';
import BaseLoader from '@/components/base/Loader';
import FormBox from '@/components/FormBox';

export default {
  components: {
    BaseContainer,
    BaseLoader,
    FormBox,
  },
  data() {
    return {
      isLoading: false,
      company: null,
    };
  },
  computed: {
    heading() {
      return this.isLoading ? '' : `${this.company.name} billing`;
    },
    lead() {
      if (this.isLoading) return '';

      const lastInvoiceUntil = this.company.invoices[0]?.paid_until;

      return lastInvoiceUntil
        ? `Paid until ${this.formatInvoiceDate(lastInvoiceUntil)}.`
        : 'Doesn\'t have paid invoices.';
    },
  },
  created() {
    this.loadCompany();
  },
  methods: {
    formatInvoiceDate(date) {
      return format(new Date(date), 'LLLL d, y');
    },
    async loadCompany() {
      this.isLoading = true;

      const { data } = await this.$apollo.query({
        query: gql`query ($companyId: Int!) {
          companies_by_pk(id: $companyId) {
            id
            name
            invoices(order_by: {paid_until: desc}) {
              id
              paid_until
            }
          }
        }`,
        variables: {
          companyId: this.$route.params.companyId,
        },
        fetchPolicy: 'no-cache',
      });

      this.company = data.companies_by_pk;

      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" module>
.page {
  flex-grow: 1;
  padding-top: map-get($page-vertical-paddings, 'small');
  padding-bottom: map-get($page-vertical-paddings, 'small');
  background: #fafafa;
}

.container {
  display: flex;
  justify-content: center;
}

.box {
  width: 470px;
}

.section {

  &:not(:first-child) {
    margin-top: 24px;
  }

  .sectionHeading {
    padding: 0;
    margin: 0 0 6px;
    font-size: 16px;
    color: $title;
  }
}

.list {
  padding: 0;
  margin: 0;
  list-style: none;

  li {
    display: block;

    &:not(:first-child) {
      margin-top: 1px;
    }
  }

  .item {
    @include reset;
    display: flex;
    align-items: center;
    padding: 6px;
    font-size: 16px;
    color: $title;
    text-decoration: none;
    background: $background-light;
    border-radius: 5px;

    .icon {
      display: inline-block;
      width: 28px;
      height: 28px;
      margin-right: 9px;
      background-color: $disabled;
      border-radius: 50%;
    }

    &.isAction {
      cursor: pointer;
      transition: background-color 0.2s ease-in-out;

      &:hover {
        background: rgba($text, 0.2);
      }
    }
  }
}
</style>
